'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@capgo/capacitor-inappbrowser';
import { buildPaymentResultPath } from '../../utils/appReturnScheme';
import { subscribeAppPaymentReturn } from './appPaymentReturnResult';

// Finishes the custom-scheme return leg: AppUrlListener recognizes the return URL via
// handleAppPaymentReturnUrl, which delivers it through the in-memory channel, and this globally
// mounted handler closes the in-app browser and routes to the result page.
const AppPaymentReturnHandler: React.FC = () => {
  const router = useRouter();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    return subscribeAppPaymentReturn((result) => {
      void (async () => {
        // The in-app browser is still open in the background on the Adyen redirect page — the
        // MobilePay app returned through the system browser, not through it. Leaving it open
        // would put the user back on a dead payment page the next time it is surfaced.
        try {
          await InAppBrowser.removeAllListeners();
          await InAppBrowser.close();
        } catch {
          // Nothing to close (the user closed it themselves, or it was never opened).
        }

        router.replace(buildPaymentResultPath(result));
      })();
    });
  }, [router]);

  return null;
};

export default AppPaymentReturnHandler;
